import React from "react";
import { options as dateOptions } from "../../utils/dateFormat";
import { options as timeOptions } from "../../utils/timeFormat";

const InviteFlowEventBanner = ({ linkData }) => {
  if (!linkData) return null;

  const { eventName, eventDate, eventLocation, invitationName } = linkData;

  const formattedDate = eventDate
    ? new Intl.DateTimeFormat("en-US", dateOptions).format(new Date(eventDate))
    : "";
  const formattedTime = eventDate
    ? new Intl.DateTimeFormat("en-US", timeOptions).format(new Date(eventDate))
    : "";

  return (
    <div className="inviteflow-banner">
      <h1 className="inviteflow-banner__event-name">{eventName}</h1>
      {invitationName && (
        <p className="inviteflow-banner__invite-name">{invitationName}</p>
      )}
      <div className="inviteflow-banner__details">
        {formattedDate && (
          <span className="inviteflow-banner__date">
            {formattedDate} · {formattedTime}
          </span>
        )}
        {eventLocation && (
          <span className="inviteflow-banner__location">{eventLocation}</span>
        )}
      </div>
    </div>
  );
};

export default InviteFlowEventBanner;
